import {
    Formik,
    FormikProps
} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {BillingProvider} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<BillingProvider, 'id'>,
    handleSubmit: (values: BillingProvider) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: BillingProvider) => {

        console.debug(values)

        handleSubmit(values);
        navigate('/billing-providers');
    };

    const onCancel = () => {
        navigate('/billing-providers');
    };


    let initialValues = {} as BillingProvider;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest as FormikProps<BillingProvider>} />
                </FormWithButtons>)}
        </Formik>
    );
};
